import Button from '../../components/Button';
import technicalSupportGraphic from './../../images/technical-support.png';
import { isMobile } from '../../helpers';

import Slide from '../components/Slide';
import { technicalSupport } from '../data/pages';

export default function TechnicalSupport() {
  const { button, dataKey, heading } = technicalSupport;
  return (
    <>
      <Slide dataKey={dataKey} heading={heading} />
      <div
        className={`relative w-full h-[165px] rounded-2xl bg-gradient-to-b from-[#81C6B9] to-[#E0E1A4] my-8 overflow-hidden`}>
        <img
          alt="Technical support graphic"
          className="absolute top-[10px] right-12 w-[350px]"
          src={technicalSupportGraphic}
        />
      </div>
      <p className="text-[16px] md:text-[18px] md:max-w-[640px]">
        For technical support, please call our Customer Service hotline{' '}
        {isMobile() ? (
          <a className="underline" href="tel:+18777974743">
            (877) 797-4743
          </a>
        ) : (
          '(877) 797-4743'
        )}{' '}
        or visit our Support page.
      </p>
      <div className="mt-[50px] md:mt-[30px]">
        <Button
          action={() => window.location.assign(button.url)}
          className="md:w-[250px]"
          title={button.title}
          data-zuko-id="technical-support_visit_support_page"
        />
      </div>
    </>
  );
}
